import firebase from '@/firebase'
const storage = firebase.storage

const state = {
  uploadFileProgress: {
    percent: 0,
    size: 0,
    task: null
  },
  modelFiles: []
}

const getters = {
  uploadFileProgress: state => {
    return state.uploadFileProgress
  },
  modelFiles: state => {
    return state.modelFiles
  }
}

const actions = {
  getFileDownloadUrl (context, payload) {
    return new Promise((resolve, reject) => {
      storage.ref().child(payload.path).getDownloadURL()
        .then((url) => {
          resolve(url)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  loadModelFiles (context, payload) {
    return new Promise((resolve, reject) => {
      storage.ref().child('files').child(payload.modelId).listAll()
        .then(async (res) => {
          /* res.prefixes.forEach((folderRef) => {
            // All the prefixes under listRef.
            // You may call listAll() recursively on them.
          }) */
          let files = []
          await res.items.forEach(async (itemRef) => {
            // All the items under listRef.
            await itemRef.getMetadata()
              .then(async (metadata) => {
                await itemRef.getDownloadURL()
                  .then((url) => {
                    files.push({
                      name: metadata.name,
                      size: metadata.size,
                      created: metadata.timeCreated,
                      contentType: metadata.contentType,
                      url: url,
                      customMetadata: metadata.customMetadata
                    })
                  })
              })
          })
          context.commit('setModelFiles', {
            modelFiles: files
          })
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  deleteModelFile (context, payload) {
    return new Promise((resolve, reject) => {
      storage.ref().child('files').child(payload.clientId).child(payload.filename).delete().then(() => {
        resolve()
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  editModelFile (context, payload) {
    return new Promise((resolve, reject) => {
      storage.ref().child('files').child(payload.clientId).child(payload.filename).updateMetadata({
        customMetadata: {
          'details': payload.details
        }
      }).then(() => {
        resolve()
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  uploadFile (context, payload) {
    return new Promise((resolve, reject) => {
      // Optional file metadata
      var metadata = {
        customMetadata: ('customMetadata' in payload) ? payload.customMetadata : null
      }
      // Lets a cross-origin download link save the file under a readable name
      if (payload.contentDisposition) {
        metadata.contentDisposition = payload.contentDisposition
      }
      var uploadTask = storage.ref().child(payload.path).put(payload.file, metadata)
      uploadTask.on('state_changed', function (snapshot) {
        var progressPercent = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        var progressSize = snapshot.bytesTransferred
        context.commit('setUploadFileProgress', {
          percent: progressPercent,
          size: progressSize,
          task: uploadTask
        })
      }, function (error) {
        console.log(error)
        reject(error)
      }, function () {
        console.log('File uploaded: ' + payload.file.name)
        resolve()
      })
    })
  },
  resetUploadFileProgress (context) {
    context.commit('setUploadFileProgress', {
      percent: 0,
      size: 0,
      task: null
    })
  }
}

const mutations = {
  setUploadFileProgress (state, payload) {
    state.uploadFileProgress = {
      percent: payload.percent.toFixed(2),
      size: payload.size,
      task: payload.task
    }
    console.log(`Uploaded ${state.uploadFileProgress.size} (${state.uploadFileProgress.percent})`)
  },
  setModelFiles (state, payload) {
    state.modelFiles = payload.modelFiles
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
